import { useState } from "react";
import { IRoadFeatureListItemProps } from "./RoadFeatureResponseList";
import { Collapse, Divider, ListItemButton, ListItemText } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import Bomstasjoner from "../../RouteDescription/Bomstasjoner";

export default function BomstasjonListItem(props: IRoadFeatureListItemProps) {
  const [open, setOpen] = useState(false);

  const onClick = () => {
        setOpen((prevstate) => !prevstate);
  };

  return(
    <>
      {props.roadFeatureResponse && 
      props.roadFeatureResponse.bomstasjoner && 
      props.roadFeatureResponse.bomstasjoner.length !== 0 &&
        <>
          <ListItemButton
            onClick={onClick}>
              <ListItemText primary={`Bomstasjoner (${props.roadFeatureResponse?.bomstasjoner.length})`}/> 
              {open ? <ExpandLess /> : <ExpandMore />} 
          </ListItemButton>
          <Collapse
            in={open}
            timeout="auto" 
            unmountOnExit
          >
            <Bomstasjoner roadFeatures={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={props.onMouseEnterItem} onMouseLeaveItem={props.onMouseLeaveItem}/>
          </Collapse>
          <Divider />
        </>
      }
    </>
  );
}